import FormInput from "./FormInput";
import FormSelect from "./FormSelect";

type Props = {
  type: string,
  nameId: string,
  label: string,
  className: string;
  placeholder: string;
  value: string;
  autoComplete: "off" | undefined;
  maxLength?: number;
  minLength?: number;
  onChange: () => void;
  children: React.ReactNode;
  typeInput?: 'input' | 'select';
  pharmacies?: {num: number}[]
};

const FormElement = ({
  type = "text",
  nameId,
  label,
  className = "reg__input",
  placeholder,
  value,
  autoComplete = "off",
  maxLength,
  minLength,
  onChange,
  typeInput = "input",
  pharmacies
  
}: Props) => {
  return (
    <div className="reg__item">
      <label htmlFor={nameId}>{label}</label>

      {typeInput === 'input' && 
        <FormInput
        type={type}
        nameId={nameId}
        className={className}
        placeholder={placeholder}
        value={value}
        autoComplete={autoComplete}
        maxLength={maxLength}
        minLength={minLength}
        onChange={onChange}
      />
      }

    {typeInput === 'select' && 
          <FormSelect
          nameId={nameId}
          className={className}
          onChange={onChange}
          pharmacies={pharmacies}
        />
      }
      
      
    </div>
  );
};

export default FormElement;
